module.exports = __webpack_public_path__ + "static/media/logo_grey_bg.58a37106.jpg";